var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodToast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#DEF7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7064 11.2928C22.8939 11.4803 22.9992 11.7346 22.9992 11.9998C22.9992 12.265 22.8939 12.5193 22.7064 12.7068L14.7064 20.7068C14.5189 20.8943 14.2646 20.9996 13.9994 20.9996C13.7343 20.9996 13.48 20.8943 13.2924 20.7068L9.29243 16.7068C9.11027 16.5182 9.00948 16.2656 9.01176 16.0034C9.01403 15.7412 9.1192 15.4904 9.30461 15.305C9.49002 15.1196 9.74083 15.0144 10.003 15.0121C10.2652 15.0098 10.5178 15.1106 10.7064 15.2928L13.9994 18.5858L21.2924 11.2928C21.48 11.1053 21.7343 11 21.9994 11C22.2646 11 22.5189 11.1053 22.7064 11.2928Z",
    fill: "#0E9F6E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodToast);
export default __webpack_public_path__ + "static/media/good-toast.0257096a676f3ebbd2966483e3532014.svg";
export { ForwardRef as ReactComponent };